import { DateTime, Duration, Interval } from 'luxon';
import { PaginationRequest } from '../pagination/pagination';

export type TimeInterval = {
  start: string;
  end: string;
};

export type DailyHours = {
  dayOfWeek: string;
  numericDayOfWeek: number;
  rentalStart: TimeInterval;
  rentalEnd: TimeInterval;
};

export type Location = {
  readonly id: number;
  readonly name: string;
  readonly phone?: string;
  readonly timezone: string;
  readonly minimumLeadTime: Duration;
  readonly maximumLeadTime: Duration;
  readonly defaultLeadTime: Duration;
  readonly defaultRentalDuration: Duration;
  readonly checkAvailability: boolean;
  readonly showRentalTimeSelect: boolean;
  readonly showRentalPrice: boolean;
  readonly showUnitsAvailable: boolean;
  readonly hoursOfOperation: DailyHours[];
  readonly rentalTimeSlots: TimeInterval[];
  readonly disabledDates: DateTime[];
  readonly currency: string;
  readonly allowNoPayment: boolean;
  readonly isActive: boolean;
  readonly isDefault: boolean;
  readonly isOffline: boolean;
  readonly totalProducts: number;
  readonly allowStripeTerminal: boolean;
  readonly address: {
    address1: string;
    address2: string;
    city: string;
    state: string;
    stateCode: string;
    zip: string;
    country: string;
  };
  readonly autoApproveAdminOrders: boolean;
  readonly autoCustomerAdminOrders: boolean;
  readonly allowDeliverySelection: boolean;
};

export class LocationSearchPaginationRequest extends PaginationRequest {
  keyword?: string;
  isActive?: boolean;
}

export type DateTimeInterval = {
  start?: DateTime;
  end?: DateTime;
};

export function mergeDateTimeIntervals(intervals: DateTimeInterval[]): DateTimeInterval[] {
  const DISTANT_PAST_DATE = DateTime.fromMillis(0);
  const DISTANT_FUTURE_DATE = DateTime.now().plus({ years: 1000 });

  return Interval.merge(
    intervals.map((i) => Interval.fromDateTimes(i.start || DISTANT_PAST_DATE, i.end || DISTANT_FUTURE_DATE)),
  ).map((i) => {
    return {
      start: i.start.toMillis() === DISTANT_PAST_DATE.toMillis() ? undefined : i.start,
      end: i.end.toMillis() === DISTANT_FUTURE_DATE.toMillis() ? undefined : i.end,
    };
  });
}

export type LocationConfiguration = {
  readonly variable: string;
  readonly value: string;
  readonly locationId: number;
};
